import http from '../../../api/httpClient';

export interface UserActions {
  add_delivery_date: number;
  set_cn_delivery_date: number;
  add_manual_ping: number;
  delete_ping: number;
  restore_ping: number;
  add_geolocation: number;
}

export interface Log {
  name: string;
  actions: UserActions;
}

export interface ActivityLogResponse {
  logs: Log[];
}

export const fetchActivityLogs = async (fromDate?: string, toDate?: string) => {
  try {
    const queryParams = new URLSearchParams({});
    if (fromDate) {
      queryParams.append('from', fromDate);
    }
    if(toDate) {
      queryParams.append('to', toDate);
    }
    const response = await http.get(`/api/v1/cto/activity-log?${queryParams}`);
    return response;
  } catch (error) {
    console.error('Error fetching activity logs:', error);
    throw error;
  }
};
